import { useContext, useMemo } from 'react';
import type { Me } from '@medicail/shared';
import { AuthContext, type AuthContextValue } from './authContext';

export function useAuthContext(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}

/** Public auth hook (also used by the admin area). */
export function useAuth(): {
  me: Me | null;
  status: 'loading' | 'authenticated' | 'unauthenticated';
  signOut(): Promise<void>;
} {
  const { me, status, signOut } = useAuthContext();
  return useMemo(() => ({ me, status, signOut }), [me, status, signOut]);
}
